module.exports = __webpack_public_path__ + "static/media/header.429c5499.png";